import React, { Suspense } from 'react'
import Card from 'src/components/Card'
import CardBody from './CardBody'
import { Table } from '@imcva/reactstrap-table'
import { columns } from './columns'

const AverageTimeToFillByContract: React.FC = (props) => {
  return (
    <>
      <Card title='Avg Time to Fill By Contract'>
        <Suspense fallback={<Table options={{ data: [], columns }} suspend={3} />}>
          <CardBody />
        </Suspense>
      </Card>
    </>
  )
}

export default AverageTimeToFillByContract
